var React = require('react');

function Female (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M64 64a64 64 0 1 1 64 64 64 64 0 0 1-64-64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M80 144h11.37a87.91 87.91 0 0 0 73.28 0H176a24 24 0 0 1 23.28 18.18l48 192A24 24 0 0 1 224 384h-56v104a24 24 0 0 1-24 24h-32a24 24 0 0 1-24-24V384H32a24 24 0 0 1-23.27-29.82l48-192A24 24 0 0 1 80 144z","className":"fa-primary","key":2})]);
}

Female.defaultProps = {"viewBox":"0 0 256 512","className":"icon"};

module.exports = Female;

Female.default = Female;
